import { useState } from "react";
import { Autocomplete, Button, Chip, FormHelperText, Grid } from "@mui/material";
import FormField from "layouts/applications/wizard/components/FormField";
import useDropdowns from "hooks/useDropdowns";
import MDBox from "components/MDBox";
import { AutoAwesome } from "@mui/icons-material";
import MDTypography from "components/MDTypography";
import CircularLoader from "components/CircularLoader";

const TagListGeneric = ({
  value = [],
  label = "Tags",
  errorMessage,
  tagOptions,
  onChange,
  onDelete,
  getLabelFromValue,
  getIdFromValue,
  ...props
}) => {
  const [inputValue, setInputValue] = useState("");
  const tagsToSelect = tagOptions?.filter((item) => {
    return !(value || []).find((valueItem) => getIdFromValue(valueItem) === getIdFromValue(item));
  });

  return (
    <div>
      <Grid container flexWrap="nowrap">
        <Grid item flexGrow={1}>
          <Autocomplete
            key="autocomplete_tagList"
            {...props}
            freeSolo
            options={
              tagsToSelect?.sort((a, b) =>
                getLabelFromValue(a).localeCompare(getLabelFromValue(b))
              ) || []
            }
            renderInput={(params) => (
              <FormField
                {...params}
                inputProps={{ ...params.inputProps, value: inputValue }}
                onChange={(e) => setInputValue(e.target.value ?? "")}
                label={label}
                type="text"
              />
            )}
            getOptionLabel={getLabelFromValue}
            onInputChange={(e) => {
              setInputValue(e.target.value ?? "");
            }}
            onChange={(e, v) => {
              e.stopPropagation();
              setInputValue("");
              onChange(v);
            }}
            onBlur={(e) => e.preventDefault()}
          />
        </Grid>
      </Grid>
      {!!value?.length && (
        <MDBox sx={{ border: "1px solid grey" }}>
          {value?.map((item, index) => (
            <Chip
              label={getLabelFromValue(item)}
              onDelete={() => onDelete(item)}
              key={getIdFromValue(item)}
              style={{ margin: "0.5em" }}
            />
          ))}
        </MDBox>
      )}
      {errorMessage && (
        <FormHelperText error sx={{ fontSize: "0.75rem" }}>
          {errorMessage}
        </FormHelperText>
      )}
    </div>
  );
};

export default TagListGeneric;
